import { Controller } from "@hotwired/stimulus"

// Small helper: toggles the "hidden" class on a targeted element.
export default class extends Controller {
  static targets = ["panel"]

  toggle() {
    this.panelTargets.forEach(t => t.classList.toggle("hidden"))
  }
}
